export const SEARCH_BAR_STYLE = Object.freeze({
  EXPANDED: 'expanded',
  MODAL: 'modal'
});

export const SELL_HUB = '/sell';
export const SELL_HUB_ALT = '/sell/';
